<ng-template #content let-modal>
  <div class="release-modal">
    <div class="modal-header">
      <div class="col-md-12">
        <button
          class="btn pull-right"
          (click)="app.releaseNotesModal.close()"
          (keydown.esc)="app.releaseNotesModal.close($event)"
        >
          <i class="fa fa-times"></i>
        </button>
        <span class="release-title fw-bold"> LCM-Client Release Notes </span>
      </div>
    </div>
    <div class="modal-body">
      <div class="col-md-12">
        <div
          *ngFor="let item of app.releaseNotesModal.mergedReleaseNotes"
          class="mb-3"
        >
          <div class="release-note-meta mb-2">
            <span class="release-version">
              {{ app.text.releaseNotesModal.version }} {{ item.version }}
            </span>
          </div>
          <div *ngFor="let change of item.changes">
            <div class="mb-3">
              <span class="bullet">&bull;</span> {{ change[app.language] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="fw-bold">
        {{ app.text.releaseNotesModal.support }}
      </div>
      <div [innerHTML]="app.text.releaseNotesModal.contact"></div>
    </div>
  </div>
</ng-template>
